<template>
    <div v-bind:class="{'right-align':userMsg}" class="message">
        <div @click="$emit('jump-to-profile',{uid:payload.sentUserUid})" v-if="msg" class="chat-user-pic"><img :src="url"></div>
        <div class="chat-message">
            <p class="user-name" @click="$emit('jump-to-profile',{uid:payload.sentUserUid})" v-if="msg">{{this.username}}</p>
            <p v-bind:id="date" v-bind:class="{'sysNoti':sysNoti,'msg':msg,'userMsg':userMsg,'error':errorMsg}">{{messageContent}} </p>
        </div>
        
    </div>
    
</template>

<script>

export default {
    name: 'message',
    props:['payload'],
    data: function(){
        return{
            sysNoti:false,
            msg:false,
            userMsg:false,
            errorMsg:false,
            messageContent:'',
            date:''
        }
    },
    computed:{
        url(){
            return this.$store.state.baseUrl+'/userPic/'+this.payload.sentUserUid
        },
        username(){
            let monitor=this.$store.state.contactRefTrace;
            return this.$store.state.contactRef[this.payload.sentUserUid];
        }
    },
    mounted(){
        switch(this.payload.type){
            case 'sysNoti':
                this.sysNoti=true;
                this.messageContent=this.payload.message;
                break;
            case 'msg':
                if(this.payload.sentUserUid && this.payload.sentUserUid===this.$store.state.UID){
                    this.userMsg=true;
                    this.messageContent=this.payload.message;
                }else{
                    this.msg=true;
                    // this.messageContent=this.payload.userName+': '+this.payload.message;
                    this.messageContent=this.payload.message;
                }
                break;
            case 'userMsg':
                this.userMsg=true;
                this.messageContent=this.payload.message;
                break;
        }
        if(this.payload.type!=='sysNoti'){
            if(this.payload.errorMsg){
                this.errorMsg=true;
            }
        }
        this.date=this.payload.date;
        if(this.$store.state.contactRef.hasOwnProperty(this.payload.sentUserUid)){
            // console.log('in ref');
            this.$emit('query-name',{uid:null});
        }else{
            // console.log('not in ref');
            this.$emit('query-name',{uid:this.payload.sentUserUid});
        }
        
    }
}
</script>

<style>
    p.small {line-height: 120%}

    .sysNoti {
        opacity: .8;
        word-break: break-all;
        text-align: center;
        position: relative;
        background: white;
        border-radius: 5px;
        margin: 0 auto;
        max-width:160px;
        word-break: break-word;
        color: #25a23b;
        padding-left: 9px;
        padding-right: 9px;
        padding-top: 4px;
        padding-bottom: 6px;
        line-height: 18px;
        font-size: 18px;
        margin-top:16px;
    }

    .msg {
        word-break: break-all;
        position: relative;
        max-width: 165px;
        background: #ffffff;
        border-radius: 5px;
        line-height: 50px;
        margin-left: 10px;
        word-break: break-word;
        color: black;
        padding-top: 0;
        padding: 9px;
        line-height: 18px;
        font-size: 18px;
        /* margin-top:16px; */
        opacity: 0.9;
    }

    .msg::after {
        content: "";
        display: block;
        position: absolute;
        width: 0;
        height: 0;
        border: 8px solid transparent;
        border-right-color: #ffffff;
        top: 5px; 
        left: -14px;
    }

    .userMsg {
        word-break:break-all;
        position: relative;
        margin-right: 10px;
        max-width: 165px;
        background: #25a23b;
        border-radius: 5px;
        line-height: 50px;
        word-break: break-word;
        color: white;
        padding: 9px;
        line-height: 18px;
        font-size: 18px;
        margin-top: 16px;
        align-self: flex-end;
    }

    .right-align {
        align-self: flex-end;
    }

    .userMsg::after {
        content: "";
        display: block;
        position: absolute;
        width: 0;
        height: 0;
        border: 8px solid transparent;
        border-left-color: #25a23b;
        top: 5px; 
        right: -15px;
    }
        
    #msgBoard .error  {
        background-color:#f66 !important;
        color:white;
    }

    .error.msg::after {
        border-right-color: #f66 !important;
    }

    .error.userMsg::after {
        border-left-color: #f66 !important;
    }


    .chat-user-pic {
        order: 0;
        width: 38px;
        height: 38px;
        border-radius: 50%;
        background-color: #8bc34a;
        margin-top: 29px;
        margin-left: 9px;
        font-size:28px;
        text-align: center;
        cursor: pointer;
        overflow: hidden;
        align-self: flex-start;
    }

    .chat-message {
        order: 1;
        display: flex;
        flex-direction: column;
    }

    .user-name {
        margin-top:14px;
        margin-left: 22px;
        margin-bottom: 2px;
        /* font-size:28px; */
        color: grey;
        line-height: 22px;
        height: 20px;
        cursor: pointer;
    }

    .chat-user-pic img {
        max-height:100%; 
        max-width:100%;
        object-fit: contain;
    }

    .message {
        display: flex;
		flex-direction: row;
        align-items: center;
    }


</style>

